export const startViewTransition=fn=>{if(typeof document!=='undefined'&&document.startViewTransition){document.startViewTransition(fn);}else{fn();}};